import LockIcon from '@mui/icons-material/Lock';
import { StyledCard, StyledRoot, StyledTypography, Wrapper } from './Section.styles';

interface SectionProps {
  title: string;
  children: React.ReactNode;
  id?: string;
}

const Section = ({ title, children, id }: SectionProps) => (
  <StyledRoot id={id}>
    <Wrapper>
      <StyledTypography>{title}</StyledTypography>
      <LockIcon fontSize="small" color="disabled" />
    </Wrapper>

    <StyledCard>{children}</StyledCard>
  </StyledRoot>
);

export default Section;
